import { SearchLoop } from 'assets/icons';
import StyledInput from 'components/styledInput/StyledInput';
import UseContext from 'hooks/useContext';

// The status the api filters on (JBWEB-1271), in the order of the select: ""
// is every status. The texts are those of the badge; `late` has none of its own
// there, since the badge adds it to the status.
const STATUS_OPTIONS = [
  { value: '', key: 'statusFilter.all', fallback: 'Tous les statuts' },
  { value: 'not_imported', key: 'status.notImported', fallback: 'Non importé' },
  { value: 'draft', key: 'status.draft', fallback: 'Brouillon' },
  { value: 'pending', key: 'status.pending', fallback: 'En attente' },
  { value: 'late', key: 'statusFilter.late', fallback: 'En retard' },
  {
    value: 'partially_paid',
    key: 'status.partiallyPaid',
    fallback: 'Partiellement payé',
  },
  { value: 'paid', key: 'status.paid', fallback: 'Payé' },
  { value: 'cancelled', key: 'status.cancelled', fallback: 'Annulée' },
  { value: 'error', key: 'status.error', fallback: 'Erreur' },
];

// The same look as the select of the payslip tab.
const SELECT_CLASS_NAME =
  'w-full h-10 pl-2 pr-3 ft-b border rounded-md text-sm focus:border-yellow-500 focus:outline-none';

/**
 * The filters of the invoice list, in the header of "Facturation": the search
 * field (JBWEB-1270), then the status (JBWEB-1271). The values are those of
 * `useInvoiceFilters`.
 */
const InvoiceFilters = ({
  searchText,
  status,
  onSearchTextChange,
  onStatusChange,
}) => {
  const { language } = UseContext();
  const text = (key, fallback) =>
    language.getValue(`invoiceList.${key}`, fallback);

  return (
    <>
      <div className="flex-1 max-w-[260px] text-sm">
        <StyledInput
          type="text"
          placeholder={text('searchPlaceholder', 'Rechercher')}
          imgFront={<SearchLoop wh={16} color="#6B7280" />}
          value={searchText}
          onChange={(event) => onSearchTextChange(event.target.value)}
        />
      </div>
      <div className="max-w-[200px]">
        <select
          aria-label={text('statusFilterLabel', 'Statut')}
          className={SELECT_CLASS_NAME}
          value={status}
          onChange={(event) => onStatusChange(event.target.value)}
        >
          {STATUS_OPTIONS.map(({ value, key, fallback }) => (
            <option key={value} value={value}>
              {text(key, fallback)}
            </option>
          ))}
        </select>
      </div>
    </>
  );
};

export default InvoiceFilters;
